/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_SubscribedInputs */



/**
* | output |
* | --- |
* | "Thanks, you are subscribed." |
*
* @param {Newsletter_SubscribedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const newsletter_subscribed = /** @type {((inputs?: Newsletter_SubscribedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_SubscribedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("谢谢，您已成功订阅。")
	return /** @type {LocalizedString} */ ("Thanks, you are subscribed.")
});